import { TriggerEvent } from 'bundles/internal-enterprise/components/InternalThirdPartyOrganizationPage/constants/AutoEnrollmentConstants';

const getTriggerEventValue = (typeName: TriggerEvent, definitionId: string, programId: string) => {
  switch (typeName) {
    case TriggerEvent.JOIN_PROGRAM: {
      return { typeName, definition: { joinedProgramId: programId } };
    }
    case TriggerEvent.ENROLL_IN_COURSE: {
      return { typeName, definition: { enrolledCourseId: definitionId } };
    }
    case TriggerEvent.COMPLETE_COURSE: {
      return { typeName, definition: { completedCourseId: definitionId } };
    }
    default: {
      throw new Error(`Unexpected typeName: ${typeName}`);
    }
  }
};

const getCreateRequestValue = (
  targetProgramId: string,
  targetCourseId: string,
  typeName: TriggerEvent,
  definitionId: string
) => {
  const triggerValue = getTriggerEventValue(typeName, definitionId, targetProgramId);
  return {
    enrollmentTarget: {
      targetProgramId,
      targetProduct: {
        typeName: 'courseEnrollment',
        definition: {
          targetCourseId,
        },
      },
    },
    triggerEvent: triggerValue,
  };
};

export const createAutoEnrollmentTrigger = (
  targetProgramId: string,
  targetProduct: string,
  typeName: TriggerEvent,
  definitionId: string
) => {
  const value = getCreateRequestValue(targetProgramId, targetProduct, typeName, definitionId);
  return fetch('/api/programEnrollmentSettings.v1/', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(value),
  });
};

export const deleteTrigger = (id: string) => {
  return fetch(`/api/programEnrollmentSettings.v1/${id}`, {
    method: 'DELETE',
  });
};

export const updateAutoEnrollmentSetting = (
  targetProgramId: string,
  targetProduct: string,
  typeName: TriggerEvent,
  definitionId: string,
  id: string
) => {
  const value = getCreateRequestValue(targetProgramId, targetProduct, typeName, definitionId);
  return fetch(`/api/programEnrollmentSettings.v1?action=replaceEnrollmentSetting&id=${id}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(value),
  });
};
